/* eslint-disable camelcase */
export function spHomepageContentClick({ name, position, url, text }) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_homepage_content_click',
        content_block: name,
        content_block_position: position.toString(),
        click_url: url,
        click_text: text
    });
}
